import React, { FC } from 'react';
import Cards from '../cards/Cards';

// Interface

export interface PageListingProps {
  childPages: [];
}
export interface NewPageListingProps {
  childPages: {
    heading: string;
    description: string;
    link: {};
    image: {};
  }[];
}

// JSX

const reshapeArray = (childPages: []) => {
  const newChildPages = [];

  childPages.map((page) => {
    newChildPages.push({
      heading: page?.properties?.feed?.shortTitle
        ? page?.properties?.feed?.shortTitle
        : page?.name,
      description: page?.properties?.feed?.shortDescription,
      link: { url: page?.url, label: 'Find out more' },
      image: page?.properties?.feed?.featuredImage,
    });
  });

  return newChildPages;
};

export const PageListing: FC<PageListingProps> = ({ childPages }) => {
  const newChildPages = reshapeArray(childPages);
  const display = 'Grid - 3 columns';

  return <Cards components={newChildPages} display={display} />;
};

export default PageListing;
